import {
  FileText,
  ImageIcon,
  MessageSquare,
  Repeat2,
  ThumbsUp,
  Video,
} from "lucide-react";
import React, { useState, useCallback, useEffect } from "react";
import Button from "../../components/form/front/Button";
import Dropdown from "../../components/form/Dropdown";
import PostComposer from "../../components/sections/front/PostComposer";
import {
  CommentAdd,
  commentList,
  postFeedList,
  saveJob,
} from "../../services/postService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSocket } from "../../providers/SocketContext";
import { useSelector } from "react-redux";
import Avatar from "../../components/form/front/Avatar";
import like from "../../assets/images/front/like-img.png";

const Post = () => {
  const [jobs, setJobs] = useState([]);
  const [loadingComments, setLoadingComments] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    fetchPosts();
  }, []);
  useSocket("postAddResponse", (res) => {
    // console.log(res, "post");
    if (res?.data) {
      handleNewPost(res.data);
    }
  });

  useSocket("reactionAddResponse", (res) => {
    // console.log("reactionAddResponse socket response:", res);
    const postId = res?.data?.post;
    const stats = res?.data?.stats;

    if (!postId || !stats) return;

    setJobs((prev) =>
      prev.map((job) =>
        job.id === postId
          ? {
            ...job,
            like: stats.likeCount ?? job.like,
            stats: {
              ...job.stats,
              ...stats,
            },
          }
          : job,
      ),
    );
  });

  useSocket("commentAddResponse", (res) => {
    const comment = res?.data?.comment;
    const stats = res?.data?.stats?.stats;

    if (!comment) return;

    const postId = comment.postId;

    const formattedComment = {
      id: comment._id,
      text: comment.content,
      user: comment.userInfo?.firstName || "User",
      userInfo: comment.userInfo,
      replies: [],
      time: "Just now",
      like: 0,
      isLike: false,
    };

    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== postId) return job;

        const exists = job.comment.some((c) => c.id === comment._id);
        if (exists) return job;

        return {
          ...job,
          comment: [...job.comment, formattedComment],
          stats: {
            ...job.stats,
            ...stats,
          },
        };
      }),
    );
  });
  const { session } = useSelector((state) => state?.authProvider);

  const loggedinUser = session?.user || {};

  const fullName =
    [loggedinUser?.firstName, loggedinUser?.lastName]
      .filter(Boolean)
      .join(" ") || "User";

  const profileImage = loggedinUser?.image?.url || null;
  const fetchPosts = async () => {
    try {
      const res = await postFeedList({ page: 1 });

      const formattedPosts = res?.docs?.data?.map((post) => {
        const isReferral = !!post.postRefDetail;

        return {
          id: post._id,
          avatar: post.authorDetails?.image?.url || null,
          slug: isReferral ? post.postRefDetail?.slug : null,
          recruiterName: `${post.authorDetails?.firstName || ""} ${post.authorDetails?.lastName || ""
            }`,

          designation: "Member",

          companyName: isReferral
            ? `${post.postRefDetail?.authorDetails?.firstName || ""} ${post.postRefDetail?.authorDetails?.lastName || ""
            }`
            : "",

          jobPost:
            post.mediaGallery?.length > 0 ? post.mediaGallery[0]?.url : "",

          location: "",

          role: isReferral
            ? post.postRefDetail?.content?.en?.title
            : post.content?.en?.title,

          description: post.content?.en?.title || "",
          mediaGallery: post.mediaGallery || [],

          like: post.stats?.likeCount || 0,
          isLike: post.selfStatus?.like || false,
          comment: [],
          stats: post.stats,
          isReferral, // 🔥 important
        };
      });

      setJobs(formattedPosts);
    } catch (err) {
      console.error(err);
    }
  };
  const [showComment, setShowComment] = useState({});
  const [commentInputs, setCommentInputs] = useState({});
  const [showReply, setShowReply] = useState({});
  const [visibleComments, setVisibleComments] = useState({});
  const [showMoreComments, setShowMoreComments] = useState({})

  const handelToggleMoreComments = (postId, id) => {
    const key = `${postId}-${id}`;

    setShowMoreComments((prev) => ({
      ...prev,
      [key]: !prev[key]
    }))

  }
  const handleNewPost = (postData) => {
    if (!postData) return;

    setJobs((prev) => {
      // prevent duplicate
      const exists = prev.some((job) => job.id === postData._id);
      if (exists) return prev;

      const isReferral = !!postData.postRefDetail;

      const formattedPost = {
        id: postData._id,
        avatar:
          postData.authorDetails?.image?.url ||
          postData.organization?.logo?.url ||
          null,
        slug: isReferral ? postData.postRefDetail?.slug : null,
        recruiterName: `${postData.authorDetails?.firstName || ""} ${postData.authorDetails?.lastName || ""
          }`,
        designation: "Member",
        companyName: isReferral
          ? `${postData.postRefDetail?.authorDetails?.firstName || ""} ${postData.postRefDetail?.authorDetails?.lastName || ""
          }`
          : "",
        jobPost: postData.mediaGallery?.[0]?.url || "",
        location: "",
        role: isReferral
          ? postData.postRefDetail?.content?.en?.title
          : postData.content?.en?.title,
        description: postData.content?.en?.title || "",
        mediaGallery: postData.mediaGallery || [],
        like: 0,
        isLike: false,
        comment: [],
        isReferral,
      };

      return [formattedPost, ...prev];
    });
  };
  // const handleLike = useCallback(
  //   async (id, referenceType = "post") => {
  //     setJobs((prev) =>
  //       prev.map((job) => {
  //         if (job.id !== id) return job;
  //         const updatedIsLike = !job.isLike;
  //         return {
  //           ...job,
  //           isLike: updatedIsLike,
  //           like: updatedIsLike ? job.like + 1 : job.like - 1,
  //         };
  //       }),
  //     );

  //     // Find the job to get its referenceId
  //     const job = jobs.find((j) => j.id === id);
  //     if (!job) return;

  //     const payload = {
  //       referenceId: job.id,
  //       referenceType, // "post" or "comment"
  //       reactionType: "like",
  //     };

  //     try {
  //       await saveJob(payload); // toggle like API
  //     } catch (err) {
  //       console.error("Failed to toggle like:", err);

  //       // revert UI if API fails
  //       setJobs((prev) =>
  //         prev.map((job) => {
  //           if (job.id !== id) return job;
  //           const revertedIsLike = !job.isLike;
  //           return {
  //             ...job,
  //             isLike: revertedIsLike,
  //             like: revertedIsLike ? job.like + 1 : job.like - 1,
  //           };
  //         }),
  //       );
  //     }
  //   },
  //   [jobs],
  // );

  const handleLike = async (id, referenceType = "post") => {
    let updatedIsLike = false;

    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== id) return job;

        updatedIsLike = !job.isLike;

        return {
          ...job,
          isLike: updatedIsLike,
          like: updatedIsLike ? job.like + 1 : job.like - 1,
        };
      }),
    );

    try {
      await saveJob({
        referenceId: id,
        referenceType,
        reactionType: "like",
      });
    } catch (err) {
      console.error("Failed to toggle like:", err);

      // revert UI
      setJobs((prev) =>
        prev.map((job) => {
          if (job.id !== id) return job;

          return {
            ...job,
            isLike: !updatedIsLike,
            like: updatedIsLike ? job.like - 1 : job.like + 1,
          };
        }),
      );
    }
  };
  const handleCommentLike = useCallback(
    async (postId, commentId) => {
      // Optimistic UI update
      setJobs((prev) =>
        prev.map((job) => {
          if (job.id !== postId) return job;
          const updatedComments = job.comment.map((c) =>
            c.id === commentId
              ? {
                ...c,
                isLike: !c.isLike,
                like: (c.like || 0) + (c.isLike ? -1 : 1),
              }
              : c,
          );
          return { ...job, comment: updatedComments };
        }),
      );

      // TODO: call API if needed
      try {
        await saveJob({
          referenceId: commentId,
          referenceType: "comment",
          reactionType: "like",
        });
      } catch (err) {
        console.error("Failed comment like:", err);
      }
    },
    [jobs],
  );
  const handleToggleComment = useCallback(
    async (postId) => {
      setShowComment((prev) => ({
        ...prev,
        [postId]: !prev[postId],
      }));
      setVisibleComments((prev) => ({
        ...prev,
        [postId]: prev[postId] || 3,
      }));

      // Fetch comments only if opening and not already loaded
      const post = jobs.find((j) => j.id === postId);
      if (!post || post.comment.length > 0) return;

      setLoadingComments((prev) => ({ ...prev, [postId]: true }));

      try {
        const res = await commentList({ postId, limit: 20, page: 1 });
        const commentsData = res?.docs?.data?.map((c) => ({
          id: c._id,
          text: c.content,
          user:
            c.userInfo?._id === "YOUR_USER_ID"
              ? "You"
              : c.userInfo?.firstName || "User",
          userInfo: c.userInfo,
          replies:
            c.descendants?.map((r) => ({
              id: r._id,
              text: r.content,
              user: r.userInfo?.firstName || "User",
              userInfo: r.userInfo,
              time: "Just now", // optional, or parse from backend
              replies: [],
            })) || [],
          time: "Just now", // optional, or parse from backend
        }));

        setJobs((prev) =>
          prev.map((job) =>
            job.id === postId ? { ...job, comment: commentsData } : job,
          ),
        );
      } catch (err) {
        console.error("Failed to fetch comments:", err);
      } finally {
        setLoadingComments((prev) => ({ ...prev, [postId]: false }));
      }
    },
    [jobs],
  );

  const handleCommentChange = useCallback((id, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [id]: value,
    }));
  }, []);

  const handleAddComment = useCallback(
    async (id) => {
      const text = commentInputs[id]?.trim();
      if (!text) return;
      const tempId = `temp-${Date.now()}`;
      // Optimistically update UI
      const newComment = {
        id: tempId,
        text,
        user: "You",
        replies: [],
        time: "Just now",
      };

      setJobs((prev) =>
        prev.map((job) =>
          job.id === id
            ? { ...job, comment: [...job.comment, newComment] }
            : job,
        ),
      );

      setCommentInputs((prev) => ({ ...prev, [id]: "" }));

      // Prepare payload for API
      const payload = {
        postId: id,
        content: text,
        // parent: optional if it's a reply
      };

      try {
        const res = await CommentAdd(payload);
        setJobs((prev) =>
          prev.map((job) =>
            job.id === id
              ? {
                ...job,
                comment: job.comment.map((c) =>
                  c.id === tempId
                    ? {
                      id: res.data._id,
                      text: res.data.content,
                      user: "You",
                      userInfo: res.data.userInfo,
                      replies: [],
                      time: "Just now",
                    }
                    : c,
                ),
              }
              : job,
          ),
        );
      } catch (err) {
        console.error("Failed to add comment:", err);
        setJobs((prev) =>
          prev.map((job) =>
            job.id === id
              ? {
                ...job,
                comment: job.comment.filter((c) => c.id !== tempId),
              }
              : job,
          ),
        );
      }
    },
    [commentInputs],
  );
  const [replyInputs, setReplyInputs] = useState({});

  const handleReplyChange = (commentId, value) => {
    setReplyInputs((prev) => ({ ...prev, [commentId]: value }));
  };

  const handleAddReply = async (postId, commentId) => {
    const text = replyInputs[commentId]?.trim();
    if (!text) return;

    // Optimistic UI
    setJobs((prev) =>
      prev.map((job) => {
        if (job.id !== postId) return job;
        const updatedComments = job.comment.map((c) =>
          c.id === commentId
            ? {
              ...c,
              replies: [
                ...(c.replies || []),
                { id: Date.now(), user: "You", text },
              ],
            }
            : c,
        );
        return { ...job, comment: updatedComments };
      }),
    );

    // ✅ clear input
    setReplyInputs((prev) => ({ ...prev, [commentId]: "" }));

    // ✅ HIDE input after reply
    setShowReply((prev) => ({
      ...prev,
      [commentId]: false,
    }));
    try {
      await CommentAdd({
        postId,
        content: text,
        parent: commentId,
      });
    } catch (err) {
      console.error("Failed to add reply:", err);
    }
  };
  const optionMenu = [
    {
      icon: "fa-regular fa-bookmark",
      name: "Save",
      click: () => alert("Saved Post"),
    },
    {
      icon: "fa-solid fa-link",
      name: "Copy Post Link",
      click: () => { },
    },
    {
      icon: "fa-regular fa-eye-slash",
      name: "Hide",
      click: () => { },
    },
    {
      icon: "fa-solid fa-code",
      name: "Embed this Post",
      click: () => { },
    },
  ];

  const commentInTime = (date) => {
    const now = dayjs()
    const seconds = now.diff(dayjs(date), "second");
    const minutes = now.diff(dayjs(date), "minute");
    const hour = now.diff(dayjs(date), "hour");
    const days = now.diff(dayjs(date), "day");
    const weeks = now.diff(dayjs(date), "week");
    const month = now.diff(dayjs(date), "month");
    const year = now.diff(dayjs(date), "year");

    if (seconds < 60) return "Just now";
    if (minutes < 60) return `${minutes}m`;
    if (hour < 24) return `${hour}h`;
    if (days < 7) return `${days}d`;
    if (weeks < 4) return `${weeks}w`;
    if (month < 12) return `${month}mo`;
    return `${year}y`;
  }

  return (
    <div className="space-y-3">
      <PostComposer onPostCreated={handleNewPost} />

      {jobs.map((job) => (
        <div
          key={job.id}
          className="p-4 mb-6 bg-white rounded-xl shadow-md relative border-b-2 border-palatte2"
        >
          <div className="flex items-center gap-3">
            {/* <img
              src={job.avatar}
              alt="profile"
              className="w-12 h-12 rounded-full"
            /> */}
            <Avatar image={job.avatar} name={job.recruiterName} size={40} />

            <div className="flex-1">
              <h3 className="text-base font-semibold text-gray-800 mb-1">
                {job.recruiterName}
              </h3>
              {/* <p className="text-xs font-medium text-gray-500">
                {job.designation}
              </p> */}
              <p className="text-xs text-gray-600 items-center">
                4w •{" "}
                <span>
                  <i class="fa-duotone fa-solid fa-earth-africa"></i>
                </span>
              </p>
            </div>
            {/* <Dropdown
              data={optionMenu}
              xPlacement="bottomRight"
              buttonClasses="p-0 border-0"
              dropdownContainer="w-52"
              button={
                <div className="w-9 h-9 flex items-center justify-center rounded-full  text-gray-700 hover:bg-gray-100 cursor-pointer">
                  <i className="fa-solid fa-ellipsis text-xl text-palatte"></i>
                </div>
              }
            /> */}
          </div>

          <div className="mt-3 text-[13px] font-medium text-gray-700 whitespace-pre-line md:pr-14">
            {job.description}
          </div>
          {job.mediaGallery?.length > 0 && (
            <div className="mt-4">
              <img
                src={job.mediaGallery[0]?.url}
                alt="post-media"
                className="w-full max-h-[300px] object-cover rounded-xl"
              />
            </div>
          )}

          {job.isReferral && (
            <div className="mt-4 border border-gray-300 shadow-[0_0_8px_rgba(0,0,0,0.1)] rounded-xl p-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                {job.jobPost && (
                  <img
                    src={job.jobPost}
                    alt="company"
                    className="w-14 h-14 rounded"
                  />
                )}
                <div>
                  <h4 className="text-base font-semibold text-gray-800">
                    {job.role}
                  </h4>
                  <p className="text-xs text-gray-700 font-medium">
                    Job by {job.companyName}
                  </p>
                  <p className="text-xs text-gray-700 font-medium">
                    {job.location}
                  </p>
                </div>
              </div>
              <Button
                buttonLabel="View job"
                buttonFunction={() => navigate(`/job/${job.slug}`)}
                buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white px-4 h-8 rounded-full border-palatte/50 border hover:bg-palatte2 font-medium"
                buttonLabelClasses="text-sm"
              />
            </div>
          )}
          <div className="flex justify-between text-[13px] font-medium text-gray-500 py-3 border-b border-palatte2">
            <span className="flex gap-1">
              {job.like > 0 && (
                <img src={like} alt="like" className="w-5 h-5" />
              )}
              {job.like} Likes
            </span>
            {/* <span>{job.stats?.commentCount || 0} comments</span> */}
            <button
              onClick={() => handleToggleComment(job.id)}
              className="text-gray-500 hover:text-palatte transition-colors"
            >
              {job.stats?.commentCount || 0}{" "}
              {(job.stats?.commentCount || 0) === 1 ? "comment" : "comments"}
            </button>
          </div>

          <div className="flex justify-around text-sm font-medium text-gray-800 mt-3">
            <button
              onClick={() => handleLike(job.id)}
              className={`flex items-center gap-1 ${job.isLike ? "text-palatte font-medium" : ""
                }`}
            >
              <ThumbsUp size={16} />
              <span>Like</span>
            </button>

            <button
              onClick={() => handleToggleComment(job.id)}
              className="flex items-center gap-1"
            >
              <MessageSquare size={16} />
              Comment
            </button>
          </div>

          {showComment[job.id] && (
            <div className="mt-4">
              {loadingComments[job.id] ? (
                <p className="text-sm text-gray-400">Loading comments...</p>
              ) : (
                <>
                  <div className="flex items-center gap-2 mt-2">
                    <Avatar image={profileImage} name={fullName} size={36} />

                    <input
                      type="text"
                      value={commentInputs[job.id] || ""}
                      onChange={(e) =>
                        handleCommentChange(job.id, e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleAddComment(job.id);
                        }
                      }}
                      placeholder="Write a comment..."
                      className="flex-1 px-3 py-2 h-10 text-sm rounded-full border-gray-300  shadow-[0_0_8px_rgba(0,0,0,0.1)] outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
                    />
                  </div>

                  {job.comment
                    .slice(0, visibleComments[job.id] || 3)
                    .map((c) => {
                      const key = `${job.id}-${c.id}`;
                      console.log("c", c)
                      return (
                        <div key={c.id} className="mt-6">
                          <div className="flex items-start gap-2">
                            <div className="flex-shrink-0">
                              <Avatar image={c.userInfo?.image?.url} name={c.user} size={32} />
                            </div>

                            <div className="flex-1">
                              <div className="">
                                <div className="leading-none">
                                  {/* Top row */}
                                  <div className="flex items-center justify-between gap-2">
                                    <p className="text-[14px] font-semibold text-gray-800 truncate">{c.user}</p>

                                    {/* {c.createdAt && (
                                      <span className="text-xs text-gray-400 whitespace-nowrap">{dayjs(c.createdAt).fromNow()}</span>
                                    )} */}
                                    <span className="text-xs text-gray-400 whitespace-nowrap">{commentInTime(c.createdAt)}</span>
                                  </div>

                                  {/* Subtitle */}
                                  <div className="max-w-xl">
                                    <p className="text-xs text-gray-500 truncate">{c.userInfo?.headline || "No headline available"}</p>
                                  </div>
                                </div>

                                {/* Comment text */}
                                <p className="text-[13px] text-gray-800 mt-0 my-1">
                                  {showMoreComments[key] || c.text?.length <= 200 ? (
                                    c.text
                                  ) : (
                                    <>
                                      {c.text.slice(0, 200)}
                                      <span
                                        onClick={() =>
                                          handelToggleMoreComments(job.id, c.id)
                                        }
                                        className="text-blue-600 cursor-pointer"
                                      >
                                        ... more
                                      </span>
                                    </>
                                  )}

                                  {showMoreComments[key] && c.text.length > 200 && (
                                    <span
                                      onClick={() =>
                                        handelToggleMoreComments(job.id, c.id)
                                      }
                                      className="text-blue-600 cursor-pointer ml-1"
                                    >
                                      show less
                                    </span>
                                  )}
                                </p>
                              </div>

                              <div className="flex gap-3 text-xs font-medium text-gray-500 mt-1">
                                <button
                                  onClick={() => handleCommentLike(job.id, c.id)}
                                  className={`flex items-center gap-1 border-r border-gray-300 pr-2 ${c.isLike ? "text-blue-600" : "text-gray-500"
                                    }`}
                                >
                                  {/* <img src={like} alt="like" className="w-4 h-4" /> */}
                                  <span>
                                    {c.isLike ? <span className="flex items-center gap-1">like <img src={like} alt="like" className="w-4 h-4 scale-x-[-1]" /> {c.like > 0 && ` · ${c.like}`}</span> : "Like"}

                                  </span>
                                </button>

                                <button
                                  onClick={() =>
                                    setShowReply((prev) => ({
                                      ...prev,
                                      [c.id]: !prev[c.id],
                                    }))
                                  }
                                >
                                  {c.replies?.length > 0
                                    ? `Reply ${c.replies.length}`
                                    : "Reply"}
                                </button>
                                {c.createdAt && (
                                  <span>{dayjs(c.createdAt).fromNow()}</span>
                                )}
                              </div>

                              {showReply[c.id] && (
                                <div className="ml-6 mt-2 flex items-center gap-2">
                                  <input
                                    type="text"
                                    value={replyInputs[c.id] || ""}
                                    onChange={(e) =>
                                      handleReplyChange(c.id, e.target.value)
                                    }
                                    onKeyDown={(e) =>
                                      e.key === "Enter" &&
                                      handleAddReply(job.id, c.id)
                                    }
                                    placeholder="Write a reply..."
                                    className="flex-1 px-3 py-2 h-8 text-sm rounded-full border-gray-300 outline-none"
                                  />
                                </div>
                              )}

                              {c.replies?.length > 0 && (
                                <div className="mt-3 ml-0 space-y-2">
                                  {c.replies.map((r) => {
                                    const replyKey = `${job.id}-${r.id}`;
                                    return (
                                      <div key={r.id} className="flex gap-2">
                                        <Avatar image={r.userInfo?.image?.url} name={r.user} size={32} />

                                        <div className="flex-1">
                                          <div className="">
                                            <div className="leading-none">
                                              {/* Top row */}
                                              <div className="flex items-center justify-between gap-2">
                                                <p className="text-base font-semibold text-gray-800 truncate">
                                                  {r.user}
                                                </p>

                                                {r.createdAt && (
                                                  <span className="text-xs text-gray-400">
                                                    {dayjs(r.createdAt).fromNow()}
                                                  </span>
                                                )}
                                              </div>

                                              {/* Subtitle */}
                                              <div className="max-w-xl">
                                                <p className="text-xs text-gray-500 truncate">{r.userInfo?.headline || "No headline available"}</p>
                                              </div>
                                            </div>

                                            {/* Comment text */}
                                            <p className="text-sm text-gray-800 mt-0 my-1">
                                              {showMoreComments[replyKey] || r.text?.length <= 200 ? (
                                                r.text
                                              ) : (
                                                <>
                                                  {r.text.slice(0, 200)}
                                                  <span
                                                    onClick={() =>
                                                      handelToggleMoreComments(job.id, r.id)
                                                    }
                                                    className="text-blue-600 cursor-pointer"
                                                  >
                                                    ... more
                                                  </span>
                                                </>
                                              )}

                                              {showMoreComments[replyKey] && r.text.length > 200 && (
                                                <span
                                                  onClick={() =>
                                                    handelToggleMoreComments(job.id, r.id)
                                                  }
                                                  className="text-blue-600 cursor-pointer ml-1"
                                                >
                                                  show less
                                                </span>
                                              )}
                                            </p>
                                          </div>

                                          <div className="flex gap-4 text-xs font-medium text-gray-500 mt-1">
                                            <button
                                              onClick={() => handleCommentLike(job.id, r.id)}
                                              className={`flex items-center gap-1 ${r.isLike ? "text-blue-600" : "text-gray-500"
                                                }`}
                                            >
                                              {/* <img src={like} alt="like" className="w-4 h-4" /> */}
                                              <span>
                                                {r.isLike ? <span className="flex items-center gap-1">like <img src={like} alt="like" className="w-4 h-4 scale-x-[-1]" /> {r.like > 0 && ` · ${r.like}`}</span> : "Like"}

                                              </span>
                                            </button>

                                            <button
                                              onClick={() =>
                                                setShowReply((prev) => ({
                                                  ...prev,
                                                  [r.id]: !prev[r.id],
                                                }))
                                              }
                                            >
                                              {r.replies?.length > 0
                                                ? `Reply ${r.replies.length}`
                                                : "Reply"}
                                            </button>
                                            {r.createdAt && (
                                              <span>{dayjs(r.createdAt).fromNow()}</span>
                                            )}
                                          </div>

                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  {(visibleComments[job.id] || 3) < job.comment.length && (
                    <div className="mt-3">
                      <button
                        onClick={() =>
                          setVisibleComments((prev) => ({
                            ...prev,
                            [job.id]: (prev[job.id] || 3) + 10,
                          }))
                        }
                        className="text-sm text-gray-700 p-2 py-1 bg-gray-100 rounded-md"
                      >
                        See more comments...
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Post;
